/* ambra-funnels.js — comportamiento compartido de los embudos AMBRA */

(function () {
  'use strict';

  /* ---------------- utilidades ---------------- */

  function buyButton() {
    return (
      document.querySelector('.product-form__submit') ||
      document.querySelector('[name="add"]') ||
      document.querySelector('button[type="submit"].product-form__submit')
    );
  }

  function buyTarget() {
    return (
      document.querySelector('#MainProduct-main') ||
      buyButton() ||
      document.querySelector('#shopify-section-main') ||
      document.querySelector('main-product')
    );
  }

  function goToBuy() {
    var el = buyTarget();
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function cfg() { return document.querySelector('[data-fnl-gate]'); }

  /* ---------------- descuento ----------------
     Camino A: /discount/CODIGO deja el descuento en la sesión de Shopify.
     Solo sirve si EasySell respeta esa sesión al crear el pedido.
  -------------------------------------------- */

  var discountTried = false;
  function preapplyDiscount(code) {
    if (!code || discountTried) return Promise.resolve();
    discountTried = true;
    return fetch('/discount/' + encodeURIComponent(code), {
      credentials: 'same-origin',
      redirect: 'follow'
    }).catch(function () {});
  }

  /* ---------------- EasySell ----------------
     Camino B: abrir el modal y rellenar dentro.
     Los selectores de la app pueden cambiar, por eso todo va con
     coincidencias flexibles y con límite de reintentos.
  -------------------------------------------- */

  function findModal() {
    var nodes = document.querySelectorAll('div, section, form');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el.offsetParent) continue;
      var cls = (el.className || '').toString().toLowerCase();
      var id = (el.id || '').toLowerCase();
      if (
        cls.indexOf('easysell') > -1 || id.indexOf('easysell') > -1 ||
        cls.indexOf('tyslo') > -1 || id.indexOf('tyslo') > -1 ||
        cls.indexOf('cod-form') > -1 || cls.indexOf('codform') > -1
      ) return el;
    }
    var couponish = document.querySelector('input[name*="coupon" i], input[name*="discount" i], input[id*="coupon" i], input[placeholder*="cupón" i], input[placeholder*="descuento" i]');
    if (couponish) return couponish.closest('form') || couponish.closest('div');
    return null;
  }

  function selectPack(scope, n) {
    if (!n) return;
    var re = new RegExp('(^|[^\\d])' + n + '\\s*FRASCO', 'i');
    var candidates = scope.querySelectorAll('label, button, [role="radio"], .es-offer, li, div');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.children.length > 4) continue;
      var txt = (el.textContent || '').trim();
      if (txt.length > 90) continue;
      if (re.test(txt)) {
        var input = el.querySelector('input[type="radio"], input[type="checkbox"]');
        if (input) { input.click(); } else { el.click(); }
        return true;
      }
    }
    return false;
  }

  function fillCoupon(scope, code) {
    if (!code) return false;
    var input = scope.querySelector('input[name*="coupon" i], input[name*="discount" i], input[id*="coupon" i], input[placeholder*="cupón" i], input[placeholder*="cupon" i], input[placeholder*="descuento" i], input[placeholder*="promo" i]');
    if (!input) return false;
    input.focus();
    input.value = code;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    var form = input.closest('form') || scope;
    var btns = form.querySelectorAll('button, a');
    for (var i = 0; i < btns.length; i++) {
      var t = (btns[i].textContent || '').trim().toLowerCase();
      if (t === 'aplicar' || t === 'apply' || t.indexOf('aplicar') === 0) { btns[i].click(); break; }
    }
    return true;
  }

  function afterModal(packIndex, code) {
    var tries = 0;
    var done = { pack: false, coupon: false };
    var timer = setInterval(function () {
      tries++;
      var modal = findModal();
      if (modal) {
        if (!done.pack) done.pack = selectPack(modal, packIndex);
        if (!done.coupon) done.coupon = fillCoupon(modal, code);
      }
      if (tries > 25 || (done.pack && done.coupon)) clearInterval(timer);
    }, 400);
  }

  function openOffer(packIndex, code) {
    preapplyDiscount(code).then(function () {
      var btn = buyButton();
      if (!btn) { goToBuy(); return; }
      btn.scrollIntoView({ behavior: 'auto', block: 'center' });
      btn.click();
      afterModal(packIndex, code);
    });
  }

  /* ---------------- clics ---------------- */

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-fnl-scroll]');
    if (!trigger) return;
    e.preventDefault();

    var c = cfg();
    var code = c ? c.getAttribute('data-fnl-code') : '';
    var autoOpen = c && c.getAttribute('data-fnl-autoopen') === '1';

    var card = trigger.closest('[data-fq-result]');
    if (card && autoOpen) {
      var key = card.getAttribute('data-fq-result') || '';
      var m = key.match(/(\d+)/);
      openOffer(m ? parseInt(m[1], 10) : 0, code);
      return;
    }
    goToBuy();
  });

  /* ---------------- puerta de oferta ----------------
     Se oculta por JS, nunca por CSS: si el script falla, la oferta
     queda visible. Mejor mostrar de más que bloquear una venta.
  -------------------------------------------------- */

  function initGate() {
    var marker = cfg();
    if (!marker) return;
    var selectors = marker.getAttribute('data-fnl-gate') || '';
    var targets = [];
    selectors.split(',').forEach(function (s) {
      var el = document.querySelector(s.trim());
      if (el) targets.push(el);
    });
    if (!targets.length) return;

    var results = [].slice.call(document.querySelectorAll('[data-fq-result]'));
    if (!results.length) return;

    var opened = false;
    function open() {
      if (opened) return;
      opened = true;
      targets.forEach(function (el) {
        el.style.display = '';
        el.removeAttribute('aria-hidden');
        el.classList.add('fnl-gate-open');
      });
    }
    targets.forEach(function (el) {
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    });

    var obs = new MutationObserver(function () {
      if (results.some(function (r) { return !r.hidden; })) { open(); obs.disconnect(); }
    });
    results.forEach(function (r) { obs.observe(r, { attributes: true, attributeFilter: ['hidden'] }); });

    setTimeout(open, 90000);
  }

  /* ---------------- CTA sticky ---------------- */

  function initSticky() {
    var bar = document.querySelector('[data-fnl-sticky]');
    if (!bar) return;
    var buy = buyTarget();
    var buyVisible = false;

    if (buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        buyVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.15 }).observe(buy);
    }
    function update() {
      var passed = window.scrollY > window.innerHeight * 0.9;
      bar.classList.toggle('is-on', passed && !buyVisible);
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    update();
  }

  function boot() { initGate(); initSticky(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
